export default "__VITE_ASSET__8eb8b10f__"